<template>
  <div v-if="isEditing" class="inline-edit-field edit">
    <slot name="edit"></slot>
    <div class="edit-actions">
      <button class="white cancel" @click="onCancel">Cancel</button>
      <button class="white save" @click="onSave">Save</button>
    </div>
  </div>
  <div v-else class="inline-edit-field" :class="{ read: isEditable }" @click="toggleEditMode">
    <slot name="read"></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from 'vue';
export default defineComponent({
  name: 'InlineEditField',
  emits: ['cancel', 'save', 'edit'],
  props: {
    isEditable: {
      type: Boolean,
      default: true,
    },
    editing: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const isEditing = ref<boolean>(false);

    const toggleEditMode = () => {
      if (!props.isEditable) return;

      isEditing.value = !isEditing.value;
    };

    const onCancel = () => {
      isEditing.value = false;
      emit('cancel');
    };
    const onSave = () => {
      isEditing.value = false;
      emit('save');
    };

    watch(isEditing, () => {
      if (isEditing.value) {
        emit('edit');
      }
    });

    onMounted(() => {
      if (props.editing) {
        isEditing.value = props.editing;
      }
    });

    return {
      isEditing,
      toggleEditMode,
      onCancel,
      onSave,
    };
  },
});
</script>

<style lang="scss">
.inline-edit-field {
  position: relative;

  &.edit {
    .edit-actions {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-top: 2px;

      button {
        font-size: var(--font-size-12);
        padding: var(--space-1);

        &.cancel {
          color: var(--grey-medium) !important;

          &:hover {
            color: var(--grey-medium) !important;
          }
        }
        &.save {
          color: var(--success-color) !important;

          &:hover {
            color: var(--success-color) !important;
          }
        }
      }
    }
  }

  &.read {
    &:hover {
      background-color: var(--grey-ultra-light);
    }
  }
}
</style>
